import { render, staticRenderFns } from "./FmaBackButton.vue?vue&type=template&id=318ffefb&scoped=true"
var script = {}
import style0 from "./FmaBackButton.vue?vue&type=style&index=0&id=318ffefb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ffefb",
  null
  
)

export default component.exports